/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import { addDays, removeTime } from 'js-date-helper';

import DatePickerBase from './date-picker.js';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { formatSimpleDate } from '../../01-helpers/utilities/date-formatter';

import { VALUE_SELECTED } from '../../02-const/event-names';
import { publish } from '../../01-helpers/event-manager';


/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */
const
	propertyKey = {
		numberOfDays: Symbol('numberOfDays')
	},
	fieldProperty = 'date';



/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */
/**
 *
 * @param {Date} startDate
 * @this DatePicker
 */
function updateSelectedRange(startDate) {
	const
		endDate = addDays(startDate, (this.numberOfNights));

	this._updateSelectedRange(startDate, endDate);
}



/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */
export default class DatePicker extends DatePickerBase {
	/* ====================================================================== *\
		CONSTRUCTOR
	\* ====================================================================== */
	constructor(baseElement, options) {
		super(baseElement, options);

		this[propertyKey.numberOfDays] = 1;
		this.filterContext = containerManager.getContainer();
	}



	/* ====================================================================== *\
		INSTANCE PROPERTIES
	\* ====================================================================== */

	/* ---------------------------------- *\
		numberOfDays
	\* ---------------------------------- */
	get numberOfDays() {
		return this[propertyKey.numberOfDays];
	}
	set numberOfDays(value) {
		if (
			!Number.isFinite(value) ||
			value <= 0
		) {
			return;
		}

		this[propertyKey.numberOfDays] = value;
		if (this.selection.start !== null) {
			updateSelectedRange.call(this, this.selection.start);
		}
	}

	/* ---------------------------------- *\
		numberOfNights
	\* ---------------------------------- */
	get numberOfNights() {
		return this[propertyKey.numberOfDays] - 1;
	}
	set numberOfNights(value) {
		this.updateSelectedRange = value + 1;
	}



	/* ====================================================================== *\
		OVERRIDDEN METHODS
	\* ====================================================================== */
	_onDateSelected(date) {
		const selectedDate = formatSimpleDate(date, '-');

		this.filterContext.update({ [fieldProperty]: selectedDate});
		updateSelectedRange.call(this, date);
		publish(VALUE_SELECTED);
	}
}
